import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../mock";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="section-cream py-20 md:py-24 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10">
        <div className="text-center">
          <div className="text-[#B45309] text-xs font-black tracking-[0.3em] uppercase">FAQs</div>
          <h2 className="section-title mt-3 text-4xl md:text-5xl font-black brand-navy">Questions? Answered.</h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="rounded-2xl border border-[#0A1740]/10 bg-white overflow-hidden shadow-sm">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="brand-navy font-bold">{f.q}</span>
                <span className="text-[#F59E0B] shrink-0">
                  {open === i ? <Minus size={18} /> : <Plus size={18} />}
                </span>
              </button>
              {open === i && (
                <div className="px-5 pb-5 text-sm text-[#0A1740]/70 leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
